import React from 'react';
import CellText from './CellText';
import CellStars from './CellStars';
import CellEvolution from './CellEvolution';
import CellPellet from './CellPellet';
import CellPrice from './CellPrice';
import CellCountry from './CellCountry';
import CellBigText from './CellBigText';
import CellMailLink from './CellMailLink';
import CellButton from './CellButton';
import CellCheckbox from './CellCheckbox';
import CellIcon from './CellIcon';
import CellRank from './CellRank';
import CellQuality from './CellQuality';
import CellExtend from './CellExtend';
import CellContact from './CellContact';

const Cell = (props) => {
  switch (props.type) {
    case 'bigText':
      return <CellBigText {...props} />;
    case 'quality':
      return <CellQuality {...props} />;
    case 'country':
      return <CellCountry {...props} />;
    case 'price':
      return <CellPrice {...props} />;
    case 'pellet':
      return <CellPellet {...props} />;
    case 'evolution':
      return <CellEvolution {...props} />;
    case 'stars':
      return <CellStars {...props} />;
    case 'mailLink':
      return <CellMailLink {...props} />;
    case 'button':
      return <CellButton {...props} />;
    case 'checkbox':
      return <CellCheckbox {...props} />;
    case 'icon':
      return <CellIcon {...props} />;
    case 'rank':
      return <CellRank {...props} />;
    case 'extend':
      return <CellExtend {...props} />;
    case 'contact':
      return <CellContact {...props} />;
    default:
      return <CellText {...props} />;
  }
};

export default Cell;
